import React, {Component} from "react";
import * as echarts from "echarts";
import {useEffect} from "react";

const ChartTrendingTrayek = ({
  dataChart,
  kodeTrayekCont = "",
  yearCont = "",
}) => {
  useEffect(() => {
    let chartDom = document.getElementById("charttrendingtrayek");
    let myChart = echarts.init(chartDom);
    let option;

    if (
      dataChart.data &&
      dataChart.data.trend_container_chart &&
      dataChart.data.trend_container_chart.length > 0
    ) {
      const dataSeries = [];
      const dataTrendContainerChart = dataChart.data.trend_container_chart;

      let maxNumber = dataTrendContainerChart.map(
        (item) => item.container.length
      )[0];

      dataTrendContainerChart
        .map((item) => item.container.length)
        .map((val, i) => {
          if (val > maxNumber) {
            maxNumber = val;
          }
        });

      const dateYear = [];
      const year = yearCont && yearCont.value ? yearCont.value : "";
      dataTrendContainerChart
        .filter((x) => x.container.length === maxNumber)[0]
        .container.map((item) => {
          dateYear.push(item.tahun);
        });

      let dataYe = [];
      if (year !== "") dataYe = dateYear.filter((x) => x === year);
      else dataYe = dateYear;
      dataSeries.push(["product", ...dataYe]);

      const kodeTrayekContV =
        kodeTrayekCont && kodeTrayekCont.value ? kodeTrayekCont.value : "";
      if (kodeTrayekContV !== "") {
        dataTrendContainerChart
          .filter((x) => x.trayek === kodeTrayekContV)
          .forEach((x) => {
            const dataContainer =
              year !== ""
                ? x.container
                    .filter((x) => x.tahun === year)
                    .map((item) => item.total_container)
                : x.container.map((item) => item.total_container);
            dataSeries.push([x.trayek, ...dataContainer]);
          });
      } else {
        dataTrendContainerChart.forEach((x) => {
          const dataContainer =
            year !== ""
              ? x.container
                  .filter((x) => x.tahun === year)
                  .map((item) => item.total_container)
              : x.container.map((item) => item.total_container);
          dataSeries.push([x.trayek, ...dataContainer]);
        });
      }

      option = {
        title: {
          text: "Trend Container Per Trayek",
        },
        legend: {},
        tooltip: {},
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        dataset: {
          source: dataSeries,
        },
        xAxis: {
          type: "category",
          axisLabel: {interval: 0, rotate: 90},
        },
        yAxis: {},
        series: dataYe.map((x) => {
          return {
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
          };
        }),
      };

      option &&
        myChart.setOption(option, {
          notMerge: true,
        });
    }
  }, [kodeTrayekCont, yearCont]);

  return (
    <div
      id="charttrendingtrayek"
      style={{
        width: "100%",
        height: "500px",
        paddingTop: "10px",
        paddingRight: "10px",
        paddingLeft: "10px",
      }}
    />
  );
};

export default ChartTrendingTrayek;
